var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 37,
    viewBox: "0 0 39 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 10C1 5.02944 5.02944 1 10 1H38V36H10C5.02944 36 1 31.9706 1 27V10Z",
    stroke: "#0885C7",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9551 25.2403V25.9383H27.224V25.2403C27.224 23.7744 26.6616 21.75 24.9747 20.4237C23.85 19.5162 22.3037 18.888 20.1247 18.888C17.9457 18.888 16.329 19.5162 15.2747 20.4237C13.5877 21.75 12.9551 23.7744 12.9551 25.2403ZM14.4312 24.4724C14.5717 23.4952 15.0638 22.3085 16.1181 21.4708C17.0319 20.7727 18.2971 20.2143 20.0544 20.2143C21.8116 20.2143 23.1471 20.7029 23.9906 21.4708C25.045 22.3085 25.537 23.4952 25.6776 24.4724C25.8182 24.4724 14.4312 24.4724 14.4312 24.4724ZM20.1247 11C18.1565 11 16.5399 12.6055 16.5399 14.5601C16.5399 16.5146 18.1565 18.1201 20.1247 18.1201C22.0928 18.1201 23.7095 16.5146 23.7095 14.5601C23.7095 12.6055 22.0928 11 20.1247 11ZM20.1247 12.4659C21.3196 12.4659 22.2334 13.4432 22.2334 14.5601C22.2334 15.677 21.2493 16.6542 20.1247 16.6542C19 16.6542 18.016 15.677 18.016 14.5601C18.016 13.4432 18.9297 12.4659 20.1247 12.4659Z",
    fill: "#0885C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.2d94546f27e19ed8020b8dc7f3a9f406.svg";
export { ForwardRef as ReactComponent };